import { render, staticRenderFns } from "./PageGestionCategorie.vue?vue&type=template&id=175fb426&scoped=true"
import script from "./PageGestionCategorie.vue?vue&type=script&lang=js"
export * from "./PageGestionCategorie.vue?vue&type=script&lang=js"
import style0 from "./PageGestionCategorie.vue?vue&type=style&index=0&id=175fb426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175fb426",
  null
  
)

export default component.exports